import { createContext, memo, ReactNode, useContext, useState } from "react";

interface InteractWithScaleContextType {
  weightInputRef: HTMLInputElement | null;
  setWeightInputRef: (ref: HTMLInputElement | null) => void;
  readFromScale: () => void;
  setReadFromScale: (readFromScale: () => void) => void;
}

export const InteractWithScaleContext =
  createContext<InteractWithScaleContextType>({
    weightInputRef: null,
    readFromScale: () => {},
    setReadFromScale: () => {},
    setWeightInputRef: () => {},
  });

const defaultInteractWithScaleContext: InteractWithScaleContextType = {
  weightInputRef: null,
  readFromScale: () => {},
  setReadFromScale: () => {},
  setWeightInputRef: () => {},
};

export const InteractWithScaleProvider = memo(
  function InteractWithScaleProvider({ children }: { children: ReactNode }) {
    const [weightInputRef, setWeightInputRef] =
      useState<HTMLInputElement | null>(null);
    const [readFromScale, setReadFromScale] = useState<() => void>(() => {});

    return (
      <InteractWithScaleContext.Provider
        value={{
          weightInputRef,
          readFromScale,
          setReadFromScale,
          setWeightInputRef,
        }}
      >
        {children}
      </InteractWithScaleContext.Provider>
    );
  },
);

export const useSafeInteractWithScale = () => {
  const interactWithScale = useContext(InteractWithScaleContext);
  if (!interactWithScale) {
    return defaultInteractWithScaleContext;
  }
  return interactWithScale;
};
